import { DocumentCountersData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';

export const documentCountersApi =
	apiResource<DocumentCountersData>('document-counters');
